import React, { useState } from 'react';
import axios from 'axios';
import { Input } from '../ui/input';
import { Button } from '../ui/button';
import { toast } from 'sonner';
import { Loader2, Phone } from 'lucide-react';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;   // 10/14: was missing /api → every save hit the app host ("Not Found")

/**
 * Josh 10/13: "if there is a lead with no phone number, let the system tell me, this way i can
 * streamline edit it and it will also save that info to the contact itself".
 * Inline editor shown wherever a text would go out but the deal's contact has no usable phone.
 * POST /collections/deals/{deal}/contact-phone writes ONLY `phone` on the linked contact.
 */
export default function ContactPhoneFix({ dealId, contactName, headers, onSaved }) {
  const [phone, setPhone] = useState('');
  const [saving, setSaving] = useState(false);

  const save = async () => {
    if (!phone.trim()) return;
    setSaving(true);
    try {
      const r = await axios.post(`${API}/collections/deals/${dealId}/contact-phone`, { phone: phone.trim() }, headers);
      toast.success(`Phone saved on ${contactName || 'the contact'}`);
      setPhone('');
      if (onSaved) await onSaved(r.data);
    } catch (e) { toast.error(e.response?.data?.detail || 'Could not save the phone'); }
    finally { setSaving(false); }
  };

  return (
    <div className="text-sm text-red-700 bg-red-50 border border-red-200 rounded p-2 flex flex-wrap items-center gap-2">
      <Phone className="h-4 w-4 shrink-0" />
      <span>No usable phone on {contactName ? <strong>{contactName}</strong> : 'the contact'}. Add it here — it is saved to the contact.</span>
      <Input className="h-8 w-44 bg-white text-slate-900" placeholder="(555) 555-5555" value={phone}
             onChange={e => setPhone(e.target.value)} onKeyDown={e => { if (e.key === 'Enter') save(); }} />
      <Button size="sm" className="h-8" disabled={saving || !phone.trim()} onClick={save}>
        {saving ? <Loader2 className="h-3.5 w-3.5 animate-spin mr-1" /> : null}Save phone
      </Button>
    </div>
  );
}
